module.exports = __webpack_public_path__ + "images/banners/estimate/progress/progress_banner_sp_9c8af4f0b48c4317bf8efc2f9c49eeee.png";